<template>
  <b-modal
    id="modal-view-webhook-log"
    ref="modal"
    v-model="open"
    size="lg"
    no-close-on-backdrop
    hide-footer
    :title="modalTitle"
  >
    <b-overlay
      :show="modalLoading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <div v-if="webhookLog">
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="Waybill Number">
              <b-form-input
                :value="webhookLog.waybill_number"
                readonly
                class="bg-light"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="Event Type">
              <b-form-input
                :value="webhookLog.event_type"
                readonly
                class="bg-light"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="Status">
              <b-badge :variant="webhookLog.success ? 'light-success' : 'light-danger'">
                {{ webhookLog.success ? 'Success' : 'Failed' }}
              </b-badge>
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="Response Code">
              <b-badge :variant="getResponseCodeVariant(webhookLog.response_code)">
                {{ webhookLog.response_code }}
              </b-badge>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="Created At">
              <b-form-input
                :value="__dateTimeFormatter(webhookLog.created_at)"
                readonly
                class="bg-light"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
          >
            <b-form-group label="Updated At">
              <b-form-input
                :value="__dateTimeFormatter(webhookLog.updated_at)"
                readonly
                class="bg-light"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group label="Payload">
              <b-form-textarea
                :value="JSON.stringify(webhookLog.payload, null, 2)"
                readonly
                rows="8"
                class="bg-light"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group label="Response Body">
              <b-form-textarea
                :value="webhookLog.response_body || 'No Response'"
                readonly
                rows="6"
                class="bg-light"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row v-if="webhookLog.error">
          <b-col cols="12">
            <b-form-group label="Error">
              <b-form-textarea
                :value="webhookLog.error"
                readonly
                rows="4"
                class="bg-light"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Close Button -->
        <b-row class="mt-3">
          <b-col
            cols="12"
            class="text-right"
          >
            <b-button
              variant="outline-secondary"
              @click="closeModal"
            >
              Close
            </b-button>
          </b-col>
        </b-row>
      </div>

      <div
        v-else-if="!modalLoading"
        class="text-center py-4"
      >
        <p class="text-muted">
          Webhook log not found
        </p>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BRow,
  BCol,
  BOverlay,
  BBadge,
  BButton,
  VBModal,
} from 'bootstrap-vue'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'

export default {
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BRow,
    BCol,
    BOverlay,
    BBadge,
    BButton,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      open: false,
      webhookLog: null,
      modalLoading: false,
      modalTitle: 'View Webhook Log',
    }
  },
  methods: {
    openModal(webhookLogData) {
      this.open = true
      this.webhookLog = webhookLogData
      this.modalTitle = `View Webhook Log - ${webhookLogData.waybill_number}`
    },
    closeModal() {
      this.open = false
      this.webhookLog = null
    },
    getResponseCodeVariant(code) {
      if (code >= 200 && code < 300) return 'success'
      if (code >= 300 && code < 400) return 'warning'
      if (code >= 400 && code < 500) return 'danger'
      if (code >= 500) return 'danger'
      return 'secondary'
    },
  },
}
</script>

<style scoped>
.bg-light {
    background-color: #f8f9fa !important;
}
</style>
